module.exports = __webpack_public_path__ + "static/media/magiris-visuels_19.5bf7b2aa.png";